import { render, staticRenderFns } from "./MbSessionList.vue?vue&type=template&id=7fad19b4&"
import script from "./MbSessionList.vue?vue&type=script&lang=js&"
export * from "./MbSessionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports